module.exports = __webpack_public_path__ + "media/assets/images/arrows/arrowUpRed-fd8761b288a1f614d897ac4e0087f322.svg";